module.exports = __webpack_public_path__ + "be6665f77101c063b34b6525dd82dace.png";